/* Import External Modules */
import React from 'react';

/* Import Leverege Modules */
import { Dialogs, Dialog } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';

/* Import Local Modules */
import LogUploadForm from './LogUploadForm';
import { SKU_TYPES, LOG_TYPES, LOCATION_TYPES } from '../../constants';

/**
 * Upload locator shipment log action.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'revert.locator.manufacturing.log',
  name: 'Revert Locator Manufacturing Log',
  matches: [{
    use: 'contextMenu',
    client: 'GroupScreen',
    objectType: 'locator',
    path: 'location.locators'
  }, {
    use: 'contextMenu',
    client: 'GroupScreen',
    objectType: 'locator',
    path: 'company.locations.locators'
  }],
  handles: context => {
    const location = DataSources.getData({
      id: context?.clientProps?.actions?.match?.params?.locationId,
      type: 'location',
      ref: context?.clientProps?.relationship?.ref
    });
    return location?.data?.type === LOCATION_TYPES.MANUFACTURING;
  },
  appearance: context => {
    return {
      name: 'Revert Manufacturing Log',
      icon: 'fa fa-undo'
    };
  },
  perform: ({
    context
  }) => {
    const {
      actions
    } = context?.clientProps || {};
    Dialogs.show({
      component: props => {
        const {
          show,
          onClose
        } = props;
        return /*#__PURE__*/_jsx(Dialog, {
          show: show,
          closeOnEscape: false,
          closeOnDocumentClick: false,
          onClose: onClose,
          variant: "logUploadDialog",
          children: /*#__PURE__*/_jsx(LogUploadForm, {
            ...props,
            onClose: onClose,
            actions: actions,
            skuType: SKU_TYPES.LOCATOR,
            logType: LOG_TYPES.MANUFACTURING,
            revert: true
          })
        });
      }
    });
  }
};